module.exports = __webpack_public_path__ + "static/img/supportingInformationNoData.09616236.png";